import { Component, OnInit } from "@angular/core";
import { User } from "../../providers";

@Component({
  selector: "app-voucher-list",
  templateUrl: "./voucher-list.component.html",
})
export class VoucherListComponent implements OnInit {
  page = 1;
  vouchers: any[] = [];
  showInfiniteScroll = false;
  showBlankState = false;

  constructor(private _user: User) {}

  ngOnInit() {
    this._getData();
  }

  handleLoadMore(infiniteScrollEvent) {
    this.page += 1;
    this._getData(infiniteScrollEvent);
  }

  private _getData(infiniteScrollEvent?: any | null) {
    this._user.getVouchers(this.page).subscribe((result) => {
      console.log(result.data);
      this.vouchers = this.vouchers.concat(result.data);
      this.showInfiniteScroll = result.pagination.hasNext;
      this.showBlankState = !this.vouchers.length;
      if (!!infiniteScrollEvent) {
        infiniteScrollEvent.complete();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/voucher-list/voucher-list.component.ts